module.exports = __webpack_public_path__ + "static/media/Sudan-Map-plain.b7ea219d.svg";